export default __webpack_public_path__ + "static/media/Eye_1_M_C1.48677300.svg";